const INITIAL_STATE = {
    list: [],
    selectedMdrItem: {
        supplierCode: '',
        rackCode: '',
        rackCodeDescription: '',
        qtdRackCode: 0,
        qtdVolume: 0
    }
};

export default function mdrReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'UPDATE_MDR_LIST':
            return {
                ...state,
                list: action.dados,
            };
        case 'CLEAR_MDR_LIST':
            return {
                ...state,
                list: INITIAL_STATE.list,
            };
        case 'SELECT_MDR_ITEM':
            return {
                ...state,
                selectedMdrItem: action.selectedItem,
            };
        default:
            return state;
    }
}
